import { useState } from "react";
import Icon from "../../../../components/HOC/Icon";
import { getAgeType } from "../../../../utils/booking/getAgeType";
import { enqueueSnackbar, useSnackbar } from "notistack";
import { Modal3 } from "../../../../components/DIsplay/Modal/Modal3";
import EditIcon from "@mui/icons-material/Edit";
import CommonFreeTextInput from "../../../../components/common/inputs/CommonFreeTextInput.jsx";
import { IconButton } from "@mui/material";
import Button1 from "../../../../components/form/Button1.js";
import EditPassengerDocumentDetail from "./modals/EditPassengerDocumentDetail.jsx";
import EditPassengerDetail from "./modals/EditPassengerDetail.jsx";
import { addCopiedPassengerToStorage } from "../../../../utils/booking/copiedPassengersStorage";
import { mapOrderPassengerToBookingTraveler } from "../../../../utils/booking/mapOrderPassengerToBookingTraveler";

export const Passengers = ({
  order,
  page,
  updatedTicket,
  onUpdateTicket,
  bookingData,
  noEdit,
  title,
}) => {
  const orderData = order?.booking?.flightBooking?.at(0);
  const [openDetail, setOpenDetail] = useState(false);
  const [travelers, setTravelers] = useState(orderData?.travelers);
  const displayedTravelers = updatedTicket?.travelers || orderData?.travelers;
  const [editTicket, setEditTicket] = useState(false);
  const [editDocumentDetail, setEditDocumentDetail] = useState(false);
  const [editDetail, setEditDetail] = useState(false);
  const handleItinerary = () => {};

  const handleCopyPassengerForBooking = (passenger) => {
    const mappedPassenger = mapOrderPassengerToBookingTraveler(passenger);
    const saved = addCopiedPassengerToStorage(mappedPassenger);

    if (!saved) {
      enqueueSnackbar("Passenger is already saved for booking.", {
        variant: "info",
      });
      return;
    }

    enqueueSnackbar("Passenger saved for future bookings.", {
      variant: "success",
    });
  };

  const inputValue = () => {
    if (!editTicket) return "";
    const [passengerIndex, ticketIndex] = editTicket
      .split("-")
      .map((item) => Number(item));
    const passenger = travelers[passengerIndex];
    const ticket = passenger?.ticketNumbers?.[ticketIndex];
    return ticket ?? "";
  };

  const handleInputChange = (value) => {
    if (!editTicket) return "";
    const [passengerIndex, ticketIndex] = editTicket
      .split("-")
      .map((item) => Number(item));
    setTravelers(
      travelers.map((traveler, traverlerIndex) => {
        if (traverlerIndex !== passengerIndex) return traveler;
        const arr = traveler.ticketNumbers ?? [];
        const next = [...arr];
        while (next.length <= ticketIndex) next.push("");
        next[ticketIndex] = value;
        return { ...traveler, ticketNumbers: next };
      }),
    );
  };

  // console.log({ order, bookingData });

  const handleSaveDraft = () => {
    if (!editTicket) return "";
    const [passengerIndex, ticketIndex] = editTicket
      .split("-")
      .map((item) => Number(item));
    const ticket = travelers[passengerIndex].ticketNumbers?.[ticketIndex];
    if (!ticket)
      return enqueueSnackbar("Ticket number is required!", {
        variant: "warning",
      });
    // const booking = updatedTicket || bookingData?.flightBooking?.at(0);
    const booking = updatedTicket || orderData;
    onUpdateTicket({ ...booking, travelers });
    setEditTicket(false);
  };

  const data = {
    order,
    bookingData,
    updatedTicket,
    onUpdateTicket,
    flightBooking:
      order?.flightBooking ||
      bookingData?.flightBooking?.at(0) ||
      order?.booking?.flightBooking?.at(0),
  };

  // console.log({ data, order });

  return (
    <div className="w-full flex flex-col mt-6">
      <EditPassengerDocumentDetail
        open={editDocumentDetail}
        setOpen={setEditDocumentDetail}
        data={data}
      />
      <EditPassengerDetail
        open={editDetail}
        setOpen={setEditDetail}
        data={data}
        // displayedTravelers={displayedTravelers}
      />
      <span className="font-bold text-xl mb-3">{title || "Passenger"}</span>
      {displayedTravelers?.map((passenger, index) => (
        <div className="flex w-full flex-col shadow-md mb-6" key={index}>
          <div className="flex flex-col lg:flex-row items-end bg-white rounded-t-lg border-b">
            <div className="items-center flex flex-wrap gap-4 px-4 py-2 flex-1 w-full ">
              <div className="flex gap-4 items-center">
                <span className="min-w-[24px] h-6 rounded-md text-white font-bold items-center justify-center flex text-sm bg-primary1">
                  {index + 1}
                </span>
                <div className="flex gap-1 items-center">
                  <div className="flex flex-col gap-2">
                    <span className="text-sm lg:text-base font-bold text-primary1 capitalize">
                      {passenger?.lastName} / {passenger?.firstName}{" "}
                      {passenger?.middleName}
                      {/* Ike/ John Chinedu */}
                    </span>
                  </div>
                  {!noEdit && (
                    <div>
                      <IconButton
                        size="small"
                        aria-label={`edit content`}
                        onClick={() => {
                          setEditDetail(`${index}`);
                        }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </div>
                  )}
                </div>
              </div>
              <div className="flex gap-1 items-start ">
                <span className="text-[#032D5F] capitalize">
                  {getAgeType(passenger?.travelerType)} {passenger?.gender}
                </span>
                {!noEdit && (
                  <div>
                    <IconButton
                      size="small"
                      aria-label={`edit content`}
                      onClick={() => {
                        setEditDetail(`${index}`);
                      }}
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </div>
                )}
              </div>
              <button
                onClick={() => setOpenDetail(passenger)}
                className="gap-2 text-sm flex-1 flex justify-end items-center text-primary/60"
              >
                Details
                <Icon
                  icon="cuida:open-in-new-tab-outline"
                  className="!w-4 !h-4 !text-theme1"
                />
              </button>
            </div>
            {order?.passengerIds?.includes(passenger?.id) && (
              <div className="text-primary1 uppercase bg-primary1/10 rounded-md py-1 px-3 w-fit text-xs my-1 mr-2">
                {page} change requested
              </div>
            )}
          </div>
          <div className="flex flex-col w-full shadow-md">
            <div className="p-4 bg-white flex flex-wrap gap-y-4 lg:gap-4 w-full">
              <div className="flex lg:flex-1 w-1/2 lg:w-fit flex-col gap-2">
                <span className="text-sm lg:text-base text-[#818083] ">
                  Date of birth
                </span>
                <div className="flex gap-1 items-center">
                  <span className=" text-sm">{passenger?.birthDate}</span>
                  {!noEdit && (
                    <div>
                      <IconButton
                        size="small"
                        aria-label={`edit nationality`}
                        onClick={() => {
                          setEditDocumentDetail(`${index}`);
                        }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </div>
                  )}
                </div>
              </div>
              <div className="flex lg:flex-1 w-1/2 lg:w-fit flex-col gap-2">
                <span className="text-sm lg:text-base text-[#818083] ">
                  Passport No
                </span>
                <div className="flex gap-1 items-center">
                  <span className="text-sm">{passenger?.document?.number}</span>
                  {!noEdit && (
                    <div>
                      <IconButton
                        size="small"
                        aria-label={`edit nationality`}
                        onClick={() => {
                          setEditDocumentDetail(`${index}`);
                        }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </div>
                  )}
                </div>
              </div>
              <div className="flex lg:flex-1 w-1/2 lg:w-fit flex-col gap-2 lg:items-center">
                <span className="text-sm lg:text-base text-[#818083] ">
                  Passport Expiry
                </span>
                <div className="flex gap-1 items-center">
                  <span className="text-sm">
                    {passenger?.document?.expiryDate}
                  </span>
                  {!noEdit && (
                    <div>
                      <IconButton
                        size="small"
                        aria-label={`edit nationality`}
                        onClick={() => {
                          setEditDocumentDetail(`${index}`);
                        }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </div>
                  )}
                </div>
              </div>
              <div className="flex lg:flex-1 w-1/2 lg:w-fit flex-col gap-2">
                <span className="text-sm lg:text-base text-[#818083] ">
                  Nationality
                </span>
                <div className="flex gap-1 items-center">
                  <span className="text-sm">
                    {passenger?.document?.nationality}
                  </span>
                  {!noEdit && (
                    <div>
                      <IconButton
                        size="small"
                        aria-label={`edit nationality`}
                        onClick={() => {
                          setEditDocumentDetail(`${index}`);
                        }}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </div>
                  )}
                </div>
              </div>
              <div className="flex lg:flex-1 sm:w-1/2 lg:w-fit flex-col gap-2">
                <span className="text-sm lg:text-base text-[#818083] ">
                  Ticket No
                </span>
                {(passenger?.ticketNumbers?.length
                  ? passenger.ticketNumbers
                  : [""]
                ).map((ticket, ticketIndex) => (
                  <div key={ticketIndex} className="flex gap-1 items-center">
                    <span className="mt-2">
                      <Copy key={ticket} value={ticket} />
                    </span>
                    {!noEdit && (
                      <div>
                        <IconButton
                          size="small"
                          aria-label={`edit ${ticketIndex}`}
                          onClick={() => {
                            setEditTicket(`${index}-${ticketIndex}`);
                          }}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                      </div>
                    )}
                  </div>
                ))}
              </div>
              <div className="flex lg:flex-1 w-1/2 lg:w-fit flex-col gap-2 lg:items-center">
                <span className="text-sm lg:text-base text-[#818083] ">
                  Itinerary
                </span>
                <img
                  src="/IconItinerary.svg"
                  alt=""
                  className="w-4 h-4 object-contain cursor-pointer"
                  onClick={() => handleItinerary()}
                />
              </div>
            </div>
          </div>
        </div>
      ))}
      <Modal3
        open={openDetail}
        setOpen={setOpenDetail}
        title="Passenger Detail"
      >
        <div>
          <div className="flex flex-col w-full shadow-md p-4">
            <div className="p-4 bg-white flex flex-wrap gap-y-4 w-full">
              <div className="flex lg:flex-1 w-1/2 lg:w-fit flex-col justify-between gap-2">
                <span className="!text-xs uppercase lg:text-base flex-1 items-center bg-theme1/10 p-2 px-4 text-[#818083] ">
                  Name
                  <div>(Last name/ Given name)</div>
                </span>
                <span className="text-sm px-4 whitespace-nowrap capitalize">
                  {openDetail?.lastName} / {openDetail?.firstName}{" "}
                  {openDetail?.middleName}
                </span>
              </div>
              <div className="flex lg:flex-1 w-1/2 lg:w-fit flex-col justify-between gap-2">
                <span className="!text-xs uppercase lg:text-base flex-1 flex items-center bg-theme1/10 p-2 px-4 text-[#818083] ">
                  Gender
                </span>
                <span className="text-sm px-4 whitespace-nowrap">
                  {openDetail?.gender}
                </span>
              </div>
              <div className="flex lg:flex-1 w-1/2 lg:w-fit flex-col justify-between gap-2">
                <span className="!text-xs uppercase lg:text-base flex-1 flex items-center bg-theme1/10 p-2 px-4 text-[#818083] ">
                  Date of birth
                </span>
                <span className="text-sm px-4 whitespace-nowrap">
                  {openDetail?.birthDate}
                </span>
              </div>
              <div className="flex lg:flex-1 w-1/2 lg:w-fit flex-col justify-between gap-2">
                <span className="!text-xs uppercase lg:text-base flex-1 flex items-center bg-theme1/10 p-2 px-4 text-[#818083] ">
                  ID No
                </span>
                <span className="text-sm px-4 whitespace-nowrap">
                  {openDetail?.document?.number}
                </span>
              </div>
              <div className="flex lg:flex-1 w-1/2 lg:w-fit flex-col justify-between gap-2">
                <span className="!text-xs uppercase lg:text-base flex-1 flex items-center bg-theme1/10 p-2 px-4 text-[#818083] ">
                  Nationality
                </span>
                <span className="text-sm px-4 whitespace-nowrap">
                  {openDetail?.document?.nationality}
                </span>
              </div>
              <div className="flex lg:flex-1 w-1/2 lg:w-fit flex-col justify-between gap-2">
                <span className="!text-xs uppercase lg:text-base flex-1 flex items-center bg-theme1/10 p-2 px-4 text-[#818083] ">
                  ID Type
                </span>
                <span className="text-sm px-4 whitespace-nowrap">
                  {openDetail?.document?.documentType}
                </span>
              </div>
              <div className="flex lg:flex-1 w-1/2 lg:w-fit flex-col justify-between gap-2 lg:items-center">
                <span className="!text-xs uppercase lg:text-base flex-1 flex items-center bg-theme1/10 p-2 px-4 text-[#818083] ">
                  ID Expiry Date
                </span>
                <span className="text-sm px-4 whitespace-nowrap">
                  {openDetail?.document?.expiryDate}
                </span>
              </div>
              <div className="flex lg:flex-1 w-1/2 lg:w-fit flex-col justify-between gap-2 lg:items-center">
                <span className="!text-xs uppercase lg:text-base flex-1 flex items-center bg-theme1/10 p-2 px-4 text-[#818083] ">
                  Frequent flyer program
                </span>
                <span className="text-sm flex-1">
                  {openDetail?.document?.frequentFlyerNo}
                </span>
              </div>
              <div className="flex lg:flex-1 w-1/2 lg:w-fit flex-col justify-between gap-2">
                <span className="!text-xs uppercase lg:text-base flex-1 flex items-center bg-theme1/10 p-2 px-4 text-[#818083] ">
                  Ticket No
                </span>
                <div className="h-[20px]">
                  {openDetail?.ticketNumbers?.map((ticket) => (
                    <Copy key={ticket} value={ticket} />
                  ))}
                </div>
              </div>
            </div>
            <div className="flex justify-end px-4 pb-4">
              <Button1
                variant="outlined"
                className="!w-auto !flex !items-center !gap-2"
                onClick={() => handleCopyPassengerForBooking(openDetail)}
              >
                <Icon icon="mdi:content-copy" className="w-4 h-4" />
                Save for booking
              </Button1>
            </div>
          </div>
        </div>
      </Modal3>
      <Modal3
        open={editTicket}
        setOpen={setEditTicket}
        title="Edit Ticket Number"
      >
        <div className="card p-6 flex flex-col gap-5 w-96">
          <CommonFreeTextInput
            value={inputValue()}
            onChange={(value) => handleInputChange(value)}
            label="Ticket No"
          />

          <div className="flex gap-3 items-center justify-end">
            <Button1
              variant="outlined"
              className="whitespace-nowrap"
              onClick={() => setEditTicket(false)}
            >
              Cancel
            </Button1>
            <Button1 onClick={handleSaveDraft}>Save Ticket No</Button1>
          </div>
        </div>
      </Modal3>
    </div>
  );
};

const Copy = ({ value }) => {
  const { enqueueSnackbar } = useSnackbar();
  const handleCopy = () => {
    try {
      navigator.clipboard.writeText(value);
      enqueueSnackbar("Copied to clipboard!", { variant: "success" });
    } catch (error) {
      enqueueSnackbar("Failed to copy to clipboard!", { variant: "error" });
    }
  };
  return (
    <div
      className="flex gap-1 items-center mb-2 cursor-pointer"
      onClick={handleCopy}
    >
      <span className="text-xs text-primary1">{value}</span>
      <img src="/IconCopy.svg" alt="" />
    </div>
  );
};
